import React, { Component } from "react";
import { connect } from "react-redux";
//import Loading from "../layout/loading";

class projectname extends Component {
  render() {
    const projectStatus = this.props.project.project_status;
    //console.log(projectStatus);
    // if (projectStatus !== "A") {
    //   return (
    //     <>
    //       <Loading />
    //     </>
    //   );
    // }
    return (
      <>
        {projectStatus === "A" && (
          <div className="box-sub-head">
            <div className="container">
              <p>{this.props.project.project_name}</p>
            </div>
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = state => ({
  project: state.project.info
});
export default connect(
  mapStateToProps,
  null
)(projectname);
